import type { MailSnoozeEntry } from "@/lib/snooze/constants";

const snoozeCache = new Map<number, MailSnoozeEntry[]>();
const listeners = new Set<() => void>();

function notify(): void {
  for (const fn of listeners) {
    fn();
  }
}

export function subscribeSnoozeCacheChanged(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function getSnoozeCache(accountId: number): MailSnoozeEntry[] | null {
  const rows = snoozeCache.get(accountId);
  return rows ? [...rows] : null;
}

export function getSnoozeCachedCount(accountId: number): number {
  return snoozeCache.get(accountId)?.length ?? 0;
}

export function setSnoozeCache(accountId: number, entries: MailSnoozeEntry[]): void {
  snoozeCache.set(accountId, entries);
  notify();
}

export function clearSnoozeRuntimeCache(accountId?: number): void {
  if (accountId == null) {
    snoozeCache.clear();
  } else {
    snoozeCache.delete(accountId);
  }
  notify();
}
